export class Sidebar {
    public $sidebar;
    public $footer;
    public $pageTitle;

    constructor() {
        this.$sidebar = document.querySelector('aside.fixed-sidebar');
        this.$footer = document.querySelector('footer');
        this.$pageTitle = document.querySelector('h1.title');

        if (this.$sidebar) {
            this.setSidebarWidth();
            this.fixedSidebar();

            window.addEventListener('resize',() => {
                this.setSidebarWidth();
                this.fixedSidebar();
            });

            window.addEventListener('scroll',() => {
                this.fixedSidebar();
            });
        }
    }

    setSidebarWidth() {
        if (window.innerWidth < 1024) {
            this.$sidebar.style.width = 'auto';
        } else {
            const sidebarColumn = this.$sidebar.closest('.column');
            const computedStyle = getComputedStyle(sidebarColumn);
            const columnWidth = sidebarColumn.getBoundingClientRect().width - parseFloat(computedStyle.paddingLeft) - parseFloat(computedStyle.paddingRight);
            this.$sidebar.style.width = columnWidth + 'px';
        }
    }

    fixedSidebar() {
        if (!this.$pageTitle || !this.$footer) return;

        const sidebarRect = this.$sidebar.getBoundingClientRect();
        const footerRect = this.$footer.getBoundingClientRect();
        const titleRect = this.$pageTitle.getBoundingClientRect();
        const spacing = 18;
        const isDetailPage = document.body.classList.contains('template_detail');

        //on mobile or if sidebar height is larger than window height: do nothing/reset
        if (window.innerWidth < 1024 || sidebarRect.height > window.innerHeight) {
            this.$sidebar.classList.remove('is-fixed');
            this.$sidebar.classList.remove('is-stuck-bottom');
            return;
        }

        const stickTop = (isDetailPage) ? titleRect.top > spacing : titleRect.bottom > spacing; //sidebar above title
        const stickBottom = sidebarRect.height + spacing > footerRect.top; //sidebar below footer
        const enoughSpaceForFixed = footerRect.top > sidebarRect.height + spacing; // enough space for sidebar to be fixed

        this.$sidebar.classList.toggle('is-fixed', !stickTop && !stickBottom && enoughSpaceForFixed);
        this.$sidebar.classList.toggle('is-stuck-bottom', !stickTop && stickBottom && !enoughSpaceForFixed);
    }
}
